<template>
  <!-- テキスト表示 & 画像 -->
  <div :id="index" @click="childAudioPlay(act.sounds[0])">
    <p v-if="dispText"><span v-html="getPopupTextElem(eText)"></span></p>
    <p v-else><span /></p>
    <div class="card">
      <div v-if="showResult" :class="{ correct: isCorrect, incorrect: isInCorrect }"></div>
      <div class="image" @touchstart="$emit('onTouchStart', act.image)"
           @touchend="$emit('onTouchEnd')" @touchmove="$emit('onTouchEnd')"><img :src="act.image"></div>
      <button v-show="showVoice" class="icon-voice" @click="audioPlay(act.sounds[0])"></button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
// 共通処理
import common from "@/mixin/common";
import runmode from "@/mixin/runmode";
import audio from "@/mixin/audio";
import jquery from "jquery";
import * as constants from "@/mixin/constants";

export default {
  name: "A1Qact",
  props: {
    act: Object,
    isCorrect: Boolean,
    isInCorrect: Boolean,
    showResult: Boolean,
    showText: Boolean,
    index: Number,
    isAnswerTarget: Boolean,
    isAnimate: Boolean
  },
  data() {
    return {
      // actのテキスト（英テキスト／日テキスト）
      eText: "",
      // actのテキストを表示するか否かを判断するフラグ
      dispText: false,
      // 一度でもテキスト表示したか否かを判断するフラグ
      isDisp: false,
      // 再生アイコンを表示するか否かを判断するフラグ
      showVoice: false
    };
  },
  mixins: [
    common,
    runmode,
    audio
  ],
  methods: {
    /**
     * 初期化処理
     */
    init: function() {
      this.log("A1Qact start init");

      if (!this.isChallenge(this.act)) {
        // givenの場合は、英文テキストを表示する
        this.changeDispAnswer();
        this.isDisp = true;
        this.showVoice = true;

        if (this.index == 0) {
          var iconVoice = $(".icon-voice");

          // 音声再生ボタンを無効にする
          iconVoice.addClass("disabled");
          $(iconVoice).prop("disabled", true);
        }
      }

      if (this.isAnswerTarget) {
        this.setAnswerTarget();
      }
    },
    /**
     * 日本語訳の表示／全解答の表示を元に戻す
     */
    changeunDisp: function() {
      this.log("A1Qact start changeunDisp");

      if (this.isDisp == false) {
        // 既に表示済みの場合は非表示にしない
        this.dispText = false;
        this.showVoice = false;
      }
      // 日本語を英文に戻す
      this.eText = this.act.basicText;
    },
    /**
     *  解答を日本語訳で表示する
     */
    changeDispJapanese: function() {
      this.log("A1Qact start changeDispJapanese");

      this.dispText = true;
      this.eText = this.act.japaneseText;
      this.showVoice = true;
    },
    /**
     *  解答を表示する
     */
    changeDispAnswer: function() {
      this.log("A1Qact start changeDispAnswer");

      this.dispText = true;
      this.eText = this.act.basicText;
      this.showVoice = true;
    },
    /**
    /* 出題時アニメーション対象のactにIDを付与する
     */
    setAnswerTarget: function() {
      const self = this;

      var targetID = "#" + this.index + " p";
      $(targetID).attr("id", "answerTarget");

      this.$emit("childSetTarget");
    },
    /**
    /* 正解テキスト領域を移動するアニメーション
    */
    Animate: function(answer) {
      const self = this;
      let answerText = this.act.basicText;

      let eleS = $("#aniTarget");
      let eleD = $("#answerTarget");
      let eleS1 = $(".toparea-play .eleAni");
      let iconVoice = $("#aniTarget").next(".icon-voice");

      let headerElem = $(".header");

      // 音声アイコンも非表示に
      iconVoice.addClass("hide");

      // 移動先の情報を取得
      let offsetTopeleS = eleS.offset().top;
      let offsetLefteleS = eleS.offset().left;

      let offsetTop = eleD.offset().top;
      let offsetLeft = eleD.offset().left;
      let eleWidth = eleD.outerWidth();
      let eleHeight = eleD.outerHeight();

      let animateTopClone = offsetTopeleS - headerElem.outerHeight();
      let animateTop = offsetTop - headerElem.outerHeight();

      let fixedSize = this.$parent.getAutoAdjustFixedSize();

      // 移動元の要素をclone
      if (!$("#cloneAniTarget").length) {
        let cloneEleS = $("#aniTarget").clone();
        cloneEleS.attr("id", "cloneAniTarget");
        cloneEleS.prependTo(".page-content");
        eleS1.css("opacity", "0");
        cloneEleS.addClass("hide");
        cloneEleS.css({
          top: animateTopClone,
          left: offsetLefteleS,
          position: "absolute",
          zIndex: 99
        });
        // 移動animate実行
        cloneEleS.stop().animate({
          top: animateTop,
          left: offsetLeft,
          width: eleWidth,
          height: eleHeight,
          zIndex: 2
        }, 500, function() {
          if (!self.isEnvironmentPc()) {
            // テキストが収まるように自動調整
            cloneEleS.textfill({
              minFontPixels: constants.AUTO_ADJUST_FONT_SIZE[self.textSize].min,
              maxFontPixels: fixedSize.cardAreaFontSize,
              allowOverflow: true
            });
          }
          self.$emit("animateEnd");
        });
      }
    },
    /**
     * 音声再生アイコン表示中のitemの音声再生処理
     */
    childAudioPlay: function(sound) {
      var iconVoice = $(".icon-voice").attr("class");
      if (iconVoice.indexOf("disabled") == -1 && this.dispText) {
        this.audioPlay(sound);
      }
    }
  },
  mounted: function() {
    this.init();
  },
  watch: {
    /**
     * テキストの表示状態を監視する
     */
    showText: function(newstatus) {
      this.log("A1Qact watch showText");

      if (this.showText == true) {
        this.dispText = true;
        this.eText = this.act.basicText;
        this.isDisp = true;
        this.showVoice = true;
      }
    },
    /**
     * 出題時アニメーション対象か否かを監視する
     */
    isAnswerTarget: function(newstatus) {
      this.log("A1Qact watch isAnswerTarget");

      if (this.isAnswerTarget) {
        this.setAnswerTarget();
      }
    },
    /**
    /* 正解したか否かを監視する
     */
    isAnimate: function() {
      if (this.isAnimate) {
        this.Animate();
      }
    },
    /**
     * ツールバー「日本語翻訳を表示する」の選択状態を監視する
     */
    dispJapaneseStatus: function(newstatus) {
      this.log("A1Qact watch dispJapaneseStatus");

      if (this.dispJapaneseStatus == false) {
        if (this.dispAllAnswerStatus == false) {
          this.changeunDisp();
        }
      } else {
        this.changeDispJapanese();
      }
    },
    /**
     * ツールバー「全解答を表示する」の選択状態を監視する
     */
    dispAllAnswerStatus: function(newstatus) {
      this.log("A1Qact watch dispAllAnswerStatus");

      if (this.dispAllAnswerStatus == false) {
        if (this.dispJapaneseStatus == false) {
          this.changeunDisp();
        }
      } else {
        this.changeDispAnswer();
      }
    },
    /**
    /* 音声再生状態を監視する
     */
    isAudioPlaying: function(newstatus) {
      this.log("A1 watch isAudioPlaying");

      var iconVoice = $(".icon-voice");

      if (this.isAudioPlaying) {
        // 音声再生ボタンを無効にする
        iconVoice.addClass("disabled");
        $(iconVoice).prop("disabled", true);
      } else {
        // 音声再生ボタンを有効にする
        iconVoice.removeClass("disabled");
        $(iconVoice).prop("disabled", false);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/card";
</style>



// WEBPACK FOOTER //
// A1Qact.vue?629cbd41